import api from "../api";

export default class ServicesApi {
	getAllDocuments() {
		return api.get("/users/discounts/documents/");
	}
	getDocumentImage() {
		return api.get("/users/discounts/documents/images/:image_id");
	}
	getHighlightIds() {
		return api.get("/users/discounts/documents/highlights/");
	}
}
